<template lang="pug">
#event-register(v-cloak)
  .box      
    .box-header.with-border.register-header
      .title
        span イベント情報登録
    .box-body.register-body
      // 開催方法
      FormInputEventHoldType(v-model="holdType" :active="2 == planType")
        template(v-slot:question)
          HelpIcon(popoverId="form-input-event-hold-type-help" title="開催方法について")
            template(v-slot:text)
              span オンライン開催の場合、イベント当日にライブ配信することが出来ます。
              span ご家族は自宅からスマートフォンで視聴出来ます。
              br
              span ※ ベーシックプランで使用可能

      // 日付・時間（開催方法により切り替え）
      template(v-if="holdType == 1")
        FormDatetimePicker(v-model="eventDatetimeFrom" :date.sync="eventDateFrom" :time.sync="eventTimeFrom"
          key-name="開始日時" name="event-datetime-from" placeholder="開始日時" :validation-rules="{ required: true }" required
          @input="onInputDatetimeFrom"
        )
        FormDatetimePicker(v-model="eventDatetimeTo" :date.sync="eventDateTo" :time.sync="eventTimeTo"
          key-name="終了日時" name="event-datetime-to" placeholder="終了日時" :validation-rules="{ required: true }" required
        )
      template(v-else-if="holdType != null")
        FormEventDatetimePicker(v-model="eventDatetime" :date.sync="eventDate" :startTime.sync="eventTimeFrom" :endTime.sync="eventTimeTo"
          key-name="日付・時間" name="event-date" placeholder="日付・時間" :validation-rules="{ required: true }" required
        )

      // 公開範囲
      FormInputEventTargetType(v-model="targetType")
      .register-row(v-show="1 <= targetType")
        .register-group
          .register-key
            span.key-name 公開先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isMountedBusy")
              b-spinner.spinner
              span 公開先読込中...
            button.btn.target-select-btn(v-else @click="showTargetSelectModal()") {{ headerTitle }}選択
            .event-target.d-flex(v-for="target in _targetEventTargetSelectModalModel")
              span.target-name.align-self-center {{ target.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteTarget(target)") X
          .error-messages(v-if="errors.has('event-targets')")
            div(v-for="error in errors.collect('event-targets')")
              label.error-message {{ error }}

      // 参加申し込み設定・参加申込み締切日、ベーシックプランのみ使用可能な機能
      FormCheck(v-model="needReply" key-name="参加申込設定" name="event-need-reply" label="参加申込み有り"
        :active="2 == planType" :disabled="planType != 2 || needReplyDisabled == true")
        template(v-slot:question)
          HelpIcon(popoverId="form-input-event-need-reply-help" title="参加申込みについて")
            template(v-slot:text)
              span ご家族がイベントの参加申込みをすることが出来ます。
              span 施設側では参加申込み状況を確認出来ます。
              br
              span オンライン開催の場合は「参加申込み有り」になります。
              br
              span ※ ベーシックプランで使用可能
      FormDatePicker(v-show="needReply == true" v-model="replyDeadline" :date.sync="replyDeadlineDate"
        key-name="参加申込み締切日" name="reply-deadline" placeholder="参加申込み締切日" required
      )

      // 場所・タイトル・内容・画像ファイル
      FormInput(v-model="place" key-name="場所" name="place" type="text" placeholder="場所" :maxlength="100"
        :validation-rules="{ required: true, max: 100 }" required)
      FormInput(v-model="title" key-name="タイトル" name="title" type="text" placeholder="タイトル" :maxlength="100"
        :validation-rules="{ required: true, max: 100 }" required)
      FormTextarea(v-model="description" key-name="内容" name="description" placeholder="内容" :maxlength="1000" :rows="7"
        :validation-rules="{ required: true, max: 1000 }" :styles="{ maxWidth: '600px', width: '600px' }" required)
      FormMultiFile(:registerImageFilesLimit="_registerFilesLimit" :enablePreviewStatus="_enablePreviewStatus"
        @inputFiles="inputFiles" @onTempFilePreview="onTempFilePreview")
      .register-row
        DraggableFiles(v-model="files" @delete="onFileDelete" :item-width="'468px'")
      FormFile(v-model="imageFile" key-name="イメージ画像ファイル" name="image-file" comment="※ファイル選択しない場合は初期画像が表示されます"
        :file-name.sync="imageName" mimetype="image/*" width="450px" :validationRules="{}" clip)
        template(v-slot:question)
          HelpIcon(:title="'選択可能なファイルについて'" :text="'jpegもしくはpngを選択可能です。'")

      // プレビュー
      .register-row
        .register-group
          .register-key
            span.key-name プレビュー
          .register-value
            EventPreview(:date="_previewDate" :timeFrom="_previewTimeFrom" :timeTo="_previewTimeTo" :place="place" :title="title"
              :description="description" :imageUrl="imageUrl" :holdType="holdType" :needReply="needReply" :replyDeadline="replyDeadline"
              :files="files")
    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      .buttons
        button.btn.register-btn(@click="showConfirmModal()" type="button") 登録
        button.btn.cancel-btn(@click="gotoEventList()" type="button") キャンセル
  img(ref="defaultImage" :src="defaultImage" style="display: none;")

  OkCancelModal(v-model="showRegisterModal" title="イベント情報を登録しますか？" @ok="registerEvent")
  OkModal(v-model="showRegisterSuccessModal" title="登録に成功しました。" @ok="gotoEventList")
  EventTargetSelectModal(v-model="isTargetSelectModal" :selectOptions="tempEventTargetSelectModalModel" :headerTitle="headerTitle" @ok="updateTarget")
  EventFilePreviewModal(ref="filePreviewModal")

  //- file upload error modal
  FileUploadErrorModal(v-model="showUploadErrorModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentUploadCount" :max="uploadCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Ref, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { EventListState } from "@/store/NeedRefreshes";
import { tabIndexesStore } from "@/store/store";
import { v4 as uuidv4 } from "uuid";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import EventsService, { EventPostModel, EventHoldType, EventTargetType, FileUrl } from "@/commons/services/Events";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import { PlanType } from "@/commons/services/Plans";
import ImgElementToBase64 from "@/commons/utils/ImgElementToBase64";
import S3LocationsService from "@/commons/services/S3Locations";
import { S3LocationRequest, S3LocationResponse, S3LocationType, S3LocationMessage } from "@/commons/models/S3Location";
import S3UploadsService from "@/commons/services/S3Uploads";
import ExistS3FilesService, { ExistS3FilesPostModel } from "@/commons/services/ExistS3Files";

import EventFileCommon from "@/commons/services/EventFileCommon";

import FileUploadErrorModal from "@/pc/basics/FileUploadErrorModal.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormFile from "@/pc/components/forms/FormFile.vue";
import FormInputEventTargetType from "@/pc/components/forms/FormInputEventTargetType.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormInputEventHoldType from "@/pc/components/forms/FormInputEventHoldType.vue";
import EventTargetSelectModal, { EventTargetSelectModalModel } from "@/pc/components/modals/EventTargetSelectModal.vue";
import EventPreview from "@/pc/basics/EventPreview.vue";
import FormEventDatetimePicker from "@/pc/components/forms/FormEventDatetimePicker.vue";
import FormDatetimePicker from "@/pc/components/forms/FormDatetimePicker.vue";
import FormDatePicker from "@/pc/components/forms/FormDatePicker.vue";
import FormMultiFile from "@/pc/containers/events/FormMultiFile.vue";
import DraggableFiles, { ExtDraggableFile } from "@/pc/components/ExtDraggableFiles.vue";
import EventFilePreviewModal from "@/pc/containers/events/EventFilePreviewModal.vue";

import eventDefaultImage from "@/assets/event-default.jpg";

/**
 * イベント登録画面コンポーネント
 */
@Component({
  components: {
    HelpIcon,
    OkCancelModal,
    OkModal,
    FileUploadErrorModal,
    FormInput,
    FormTextarea,
    FormFile,
    FormInputEventTargetType,
    FormCheck,
    FormInputEventHoldType,
    EventTargetSelectModal,
    EventPreview,
    FormEventDatetimePicker,
    FormDatetimePicker,
    FormDatePicker,
    FormMultiFile,
    DraggableFiles,
    EventFilePreviewModal,
    PageLoading,
    ProgressLoading,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class EventRegister extends Vue {
  /** イベントサービス */
  @Inject("EventsService") eventsService!: EventsService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** S3格納先URLサービス */
  @Inject("S3LocationsService") s3LocationsService!: S3LocationsService;
  /** S3ファイルアップロードサービス */
  @Inject("S3UploadsService") s3UploadsService!: S3UploadsService;
  /** S3ファイル存在確認サービス */
  @Inject("ExistS3FilesService") existS3FilesService!: ExistS3FilesService;

  @Ref()
  filePreviewModal!: EventFilePreviewModal;

  /** 添付許可Content-Typeリスト */
  readonly allowContentType = ["application/pdf"];
  readonly allowMessageType = ["pdf"];
  /** ファイル登録数 */
  readonly registerFileUploadLimit: number = 1;

  /** 画面初期表示読込み */
  isMountedBusy: boolean = false;
  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 宛先選択モーダル表示可否 */
  isTargetSelectModal: boolean = false;
  /** 登録確認モーダル表示可否 */
  showRegisterModal: boolean = false;
  /** 登録完了モーダル表示可否 */
  showRegisterSuccessModal: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** イベント日時 (オンライン用) */
  eventDatetime: number | null = null;
  /** 日付 */
  eventDate: string = "";
  /** 開始時刻 */
  eventTimeFrom: string = "";
  /** 終了時刻 */
  eventTimeTo: string = "";

  /** 開始日時 (現地開催用 17桁数値) */
  eventDatetimeFrom: number | null = null;
  /** 開始日付 */
  eventDateFrom: string = "";
  /** 終了日時 (現地開催用 17桁数値) */
  eventDatetimeTo: number | null = null;
  /** 終了日付 */
  eventDateTo: string = "";

  /** 宛先種別 */
  targetType: EventTargetType | null = null;
  /** 開催方法 */
  holdType: EventHoldType | null = null;
  /** 参加申込設定 */
  needReply: boolean = false;
  /** 参加申し込み設定、値変更可否 */
  needReplyDisabled: boolean = false;
  /** 参加申込み締切日時 */
  replyDeadline: number = 0;
  /** 参加申込み締切日 */
  replyDeadlineDate: string | null = "";
  /** 場所 */
  place: string = "";
  /** タイトル */
  title: string = "";
  /** 内容 */
  description: string = "";
  /** 実際に登録するファイル */
  files: Array<ExtDraggableFile> = [];
  /** ファイル選択コンポーネントで選択したファイル */
  imageFile: any = null;
  /** ファイル選択コンポーネントで選択したファイルのURL */
  imageUrl: string = "";
  /** ファイル選択コンポーネントで選択したファイル名 */
  imageName: string = "";
  /** イベントの画像が無い場合に表示するデフォルト画像 */
  defaultImage: string = eventDefaultImage;

  /** 宛先選択モーダルのタイトル */
  headerTitle: string = "利用者グループ";
  /** 宛先種別が「利用者グループ」の場合の宛先種別選択肢 */
  residentGroups: Array<EventTargetSelectModalModel> = [];
  /** 宛先 */
  eventTargetSelectModalModel: Array<EventTargetSelectModalModel> = [];
  /** 宛先選択肢(キャンセル等がありえるので一時コピーした宛先を子コンポーネントに渡す) */
  tempEventTargetSelectModalModel: Array<EventTargetSelectModalModel> = [];

  /** 現在のファイルアップロード数 */
  currentUploadCount: number = 0;
  /** ファイルアップロード総数 */
  uploadCount: number = 0;
  /** プログレスモーダルメッセージ */
  progressMessage: string = "";
  /** プログレスモーダル表示可否 */
  progressLoading: boolean = false;
  /** ファイルアップロードエラーモーダル表示可否 */
  showUploadErrorModal: boolean = false;

  /**
   * ### 開催方法の変更イベント
   *
   * @param newValue 変更後の開催方法 (`EventHoldType`)
   * @param oldValue 変更前の開催方法 (`EventHoldType`)
   *
   * 【処理の仕様・背景】
   * 1. **日時入力のリセット**:
   *    開催方法（「現地のみ」または「オンライン含む」）によって日時入力コンポーネントやデータの管理形式が切り替わるため、
   *    旧フォームで入力されていた日時情報を破棄して再入力を促します。
   *    ※ `oldValue != null` の判定により、画面の初期表示（プロパティへの初回代入時）にリセットが誤発火するのを防止しています。
   *
   * 2. **旧日時項目のバリデーションエラー除去**:
   *    開催方法の変更で旧日時の入力フォームが画面から消去されるため、旧日時項目で発生していたエラー
   *    (`event-datetime-from`, `event-datetime-to`, `event-date`) を明示的に破棄します。
   *
   * 3. **ValidationAlert（画面下部全体エラー警告）の非表示制御**:
   *    旧日時エラーの除去後、フォーム全体の残りエラー数を `0 < this.$validator.errors.count()` でチェックします。
   *    - 他の項目（タイトル・場所等）にエラーが無い場合: エラーメッセージが空のアラートだけが画面に残るのを防ぐため、`showValidationAlert` を `false` にして閉じます。
   *    - 他の項目にエラーが残っている場合: 他項目の警告表示を継続するため、`showValidationAlert` を `true` のまま維持します。
   *
   * 4. **オンライン開催時の参加申込設定の自動有効化**:
   *    オンラインに関わる開催（`ONLINE_ONLY` または `LOCAL_AND_ONLINE`）の場合は申込情報が必要となるため、
   *    参加申込設定 (`needReply`) を強制的に `true` に変更し、設定変更を不可 (`needReplyDisabled = true`) に制御します。
   */
  @Watch("holdType")
  public changeHoldType(newValue: EventHoldType, oldValue?: EventHoldType): void {
    if (oldValue != null && newValue !== oldValue) {
      // 1. 日時入力要素の初期化
      this.resetDatetime();
      // 2. 切り替え前の日時項目に対する残存バリデーションエラーを削除
      this.$validator.errors.remove("event-datetime-from");
      this.$validator.errors.remove("event-datetime-to");
      this.$validator.errors.remove("event-date");
      // 3. 他項目（タイトル・場所等）にエラーが残っていなければ全体警告アラートを閉じる
      this.showValidationAlert = 0 < this.$validator.errors.count();
    }

    if (newValue == EventHoldType.ONLINE_ONLY || newValue == EventHoldType.LOCAL_AND_ONLINE) {
      this.needReply = true;
      this.needReplyDisabled = true;
    } else {
      this.needReplyDisabled = false;
    }

    return;
  }

  /**
   * ### 日時入力のリセット
   *
   * - 開催方法変更時などに保持しているオンライン用・現地開催用すべての日時変数を初期化する
   */
  public resetDatetime(): void {
    this.eventDatetime = null;
    this.eventDate = "";
    this.eventDatetimeFrom = null;
    this.eventDateFrom = "";
    this.eventTimeFrom = "";
    this.eventDatetimeTo = null;
    this.eventDateTo = "";
    this.eventTimeTo = "";
    return;
  }

  /**
   * ### 開始日時入力時の終了日時自動連動
   *
   * @param val 入力された開始日時 (17桁の数値または null)
   *
   * - 「現地開催のみ」において開始日時が指定された際、終了日時が未入力の場合に限り、
   *   入力の手間を省くため開始日時と同じ値を終了日時のデフォルト値として自動設定する
   */
  public onInputDatetimeFrom(val: number | null): void {
    if (val && (!this.eventDatetimeTo || !this.eventDateTo)) {
      this.eventDatetimeTo = val;
      this.eventDateTo = this.eventDateFrom;
      this.eventTimeTo = this.eventTimeFrom;
    }
    return;
  }

  /**
   * FileSelecterコンポーネントにバインドした画像の変更イベント
   * ファイル選択、ファイル削除時に呼ばれる
   */
  @Watch("imageFile")
  public async changeImageFile(newFile: string): Promise<void> {
    if (newFile) {
      this.imageUrl = newFile;
    } else {
      this.imageUrl = "";
    }

    return;
  }

  get _targetEventTargetSelectModalModel(): Array<EventTargetSelectModalModel> {
    let targets: Array<EventTargetSelectModalModel> = [];

    for (const target of this.eventTargetSelectModalModel) {
      if (target.isChecked == true) {
        targets.push(target);
      }
    }

    return targets;
  }

  /**
   * ### 登録可能なファイル数を返す
   */
  get _registerFilesLimit(): number {
    const limit: number = this.registerFileUploadLimit - this.files.length;
    return limit;
  }

  /**
   * ### プレビュー表示可否を返す
   */
  get _enablePreviewStatus(): boolean {
    return 0 < this.files.length ? true : false;
  }

  get _previewTimeFrom(): string {
    if (this.holdType == EventHoldType.LOCAL_ONLY) {
      return this.eventDatetimeFrom ? String(this.eventDatetimeFrom) : "";
    } else {
      return this.eventTimeFrom;
    }
  }

  get _previewTimeTo(): string {
    if (this.holdType == EventHoldType.LOCAL_ONLY) {
      return this.eventDatetimeTo ? String(this.eventDatetimeTo) : "";
    } else {
      return this.eventTimeTo;
    }
  }

  get _previewDate(): number | null {
    if (this.holdType == EventHoldType.LOCAL_ONLY) {
      return this.eventDatetimeFrom;
    } else {
      return this.eventDatetime;
    }
  }

  /**
   * ### vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);

    const today: Date = new Date();
    this.replyDeadline = this.$dateUtil.convertDateToNumber(today, "yyyymmdd000000000");
    this.replyDeadlineDate = this.$dateUtil.convertDateToString(today, "yyyy-mm-dd");

    return;
  }

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.planType = userStore.facility.planType;
    await this.createView();

    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public async createView(): Promise<void> {
    this.isMountedBusy = true;

    const groups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    let residentGroups: Array<EventTargetSelectModalModel> = [];
    for (const group of groups) {
      const residentGroup: EventTargetSelectModalModel = {
        name: group.name,
        id: group.id,
        isChecked: false
      };
      residentGroups.push(residentGroup);
    }
    this.residentGroups = residentGroups;

    this.isMountedBusy = false;

    return;
  }

  /**
   * ### 利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const groups: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return groups;
  }

  /**
   * ### 宛先選択モーダルを表示する
   */
  public showTargetSelectModal(): void {
    switch (this.targetType) {
      case EventTargetType.RESIDENT_GROUP: {
        this.eventTargetSelectModalModel = this.residentGroups;
        break;
      }
      default: {
        this.eventTargetSelectModalModel = [];
      }
    }

    this.tempEventTargetSelectModalModel = JSON.parse(JSON.stringify(this.eventTargetSelectModalModel));
    this.isTargetSelectModal = true;

    return;
  }

  /**
   * ### 宛先選択結果を格納する
   */
  public updateTarget(targets: Array<EventTargetSelectModalModel>): void {
    switch (this.targetType) {
      case EventTargetType.RESIDENT_GROUP: {
        this.residentGroups = targets;
        this.eventTargetSelectModalModel = this.residentGroups;
        break;
      }
      default: {
        this.eventTargetSelectModalModel = [];
      }
    }

    return;
  }

  /**
   * ### 宛先を削除する
   */
  public deleteTarget(target: EventTargetSelectModalModel): void {
    target.isChecked = false;
    return;
  }

  /**
   * ### 子コンポーネントでファイルが選択された場合のイベント処理
   *
   * - ファイルが上限数以上なら無視する
   * - バリデーションを行う
   * - バリデーションエラーでなければ、ファイルを追加する
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const fileCommon: EventFileCommon = new EventFileCommon(this.$validator, "tempfiles-multiple-register-errors");
    const addFiles: Array<ExtDraggableFile> = await fileCommon.createAddFile(files, this.registerFileUploadLimit, this.files.length);

    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);
      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    this.isBusy = false;
    return;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public onTempFilePreview(): void {
    const files = [];
    for (const file of this.files) {
      files.push(file.fileObject as File);
    }
    if (this.filePreviewModal && this.filePreviewModal instanceof EventFilePreviewModal) {
      this.filePreviewModal.show("", false, files);
    }
    return;
  }

  /**
   * ### 指定されたファイルを削除する
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 登録確認モーダルを表示する
   *
   * - 表示前にバリデーションチェックして、エラーならモーダルは表示しない
   */
  public async showConfirmModal(): Promise<void> {
    // チェック結果を初期化してからチェックしないと、エラーメッセージが残り続けてしまう
    this.$validator.errors.remove("event-targets");
    this.$validator.errors.remove("event-datetime-to");
    this.$validator.errors.remove("event-date");

    const validationResult: boolean = await this.$validator.validateAll();
    const eventTargetsValidationResult: boolean = this.validateEventTarget(this.targetType as EventTargetType, this.eventTargetSelectModalModel);
    const replyDeadlineValidationResult: boolean = this.validationReplyDeadline(this.needReply as boolean, this.replyDeadline);
    const eventTimeValidationResult: boolean = this.validationEventTime();

    if (validationResult == true && eventTargetsValidationResult == true && replyDeadlineValidationResult == true && eventTimeValidationResult == true) {
      this.showValidationAlert = false;
      this.showRegisterModal = true;
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### 日付存在チェックバリデーション
   *
   * @param eventDate 判定対象の日付数値 (YYYYMMDD000000000 形式)
   * @returns 正常または判定不要(null)の場合 true、存在しない日付の場合 false
   *
   * - 引数が null の場合は必須チェックで別途判定するため true を返す
   * - 存在しない年月日（例: 2月31日等）の場合は false を返す
   */
  public validateEventDate(eventDate: number | null): boolean {
    if (eventDate == null) {
      return true;
    }

    const existDate = this.$dateUtil.checkExistDate(eventDate);
    return existDate;
  }

  /**
   * ### 宛先（公開先）バリデーション
   *
   * @param targetType 宛先種別 (0: 全体, 1: 利用者グループ)
   * @param targets 選択中の宛先リスト
   * @returns バリデーション結果 (正常: true, エラー: false)
   *
   * - 宛先種別が「全体 (`ALL` / 0)」の場合はチェック不要で true を返す
   * - 宛先種別が「利用者グループ (`RESIDENT_GROUP` / 1)」の場合、少なくとも1つのグループが選択されているか判定する
   * - 1つも選択されていない場合はエラーメッセージ「公開先は必須項目です」を追加して false を返す
   */
  public validateEventTarget(targetType: EventTargetType, targets: Array<EventTargetSelectModalModel>): boolean {
    if (targetType == EventTargetType.ALL) {
      return true;
    }

    for (const target of targets) {
      if (target.isChecked == true) {
        return true;
      }
    }

    this.$validator.errors.add({ field: "event-targets", msg: "公開先は必須項目です" });

    return false;
  }

  /**
   * ### 参加申込み締切日のバリデーション
   *
   * @param needRply 参加申込の有無 (true: 申込み有り)
   * @param replyDeadline 申込み締切日数値 (YYYYMMDD000000000 形式)
   * @returns バリデーション結果 (正常: true, エラー: false)
   *
   * - 参加申込み有りの場合のみ以下を検証する：
   *   1. 必須チェック: 未入力の場合は「参加申込み締切日は必須項目です」
   *   2. 日付存在チェック: 実在しない日付の場合は「参加申込み締切日は存在しない年月日です」
   *   3. イベント開始日時との前後比較:
   *      イベントの開始日付（現地開催の場合は `eventDatetimeFrom`、オンライン含む場合は `eventDatetime`）よりも
   *      締切日が未来（後）の日付になっている場合は「参加申込み締切日が日付より未来です」のエラーを返す
   */
  public validationReplyDeadline(needRply: boolean, replyDeadline: number): boolean {
    let replyDeadlineValidationResult: boolean = true;

    if (needRply == true) {
      if (!replyDeadline) {
        this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日は必須項目です" });
        replyDeadlineValidationResult = false;
      } else {
        const existDate = this.$dateUtil.checkExistDate(replyDeadline);
        if (existDate == false) {
          this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日は存在しない年月日です" });
          replyDeadlineValidationResult = false;
        }

        let startDatetimeNum: number | null = null;
        if (this.holdType == EventHoldType.LOCAL_ONLY) {
          startDatetimeNum = this.eventDatetimeFrom;
        } else if (this.eventDatetime) {
          startDatetimeNum = this.eventDatetime;
        }

        if (startDatetimeNum != null) {
          const slicedEventDatetime: string = startDatetimeNum.toString().slice(0, 8);
          const slicedReplyDeadline: string = replyDeadline.toString().slice(0, 8);

          if (Number(slicedEventDatetime) < Number(slicedReplyDeadline)) {
            this.$validator.errors.add({ field: "reply-deadline", msg: "参加申込み締切日が日付より未来です" });
            replyDeadlineValidationResult = false;
          }
        }
      }
    }

    return replyDeadlineValidationResult;
  }

  /**
   * ### イベント日時の整合性バリデーション
   *
   * @returns バリデーション結果 (正常: true, エラー: false)
   *
   * 開催方法 (`holdType`) に応じて以下の日時整合性をチェックする：
   *
   * 1. **現地開催のみ (`LOCAL_ONLY` / 1)**:
   *    - 開始日時 (`eventDatetimeFrom`) と 終了日時 (`eventDatetimeTo`) を比較する。
   *    - 終了日時は開始日時より後の日時でなければならない（`eventDatetimeTo > eventDatetimeFrom`）。
   *    - 条件を満たさない場合は「終了日時は開始日時より後の日時を指定してください」のエラーを追加する。
   *
   * 2. **オンライン開催 / 現地とオンライン (`ONLINE_ONLY` / 2, `LOCAL_AND_ONLINE` / 0)**:
   *    - 開始時刻 (`eventTimeFrom`) と 終了時刻 (`eventTimeTo`) を比較する。
   *    - 終了時間は開始時間より後の時間でなければならない（`toNum > fromNum`）。
   *    - オンラインイベントの配信制限として、実施時間は **1時間以内** (差分 <= 60分) でなければならない。
   *    - 1時間を超える場合は「オンラインイベントの場合、実施時間は1時間までです」のエラーを追加する。
   */
  public validationEventTime(): boolean {
    let validationResult: boolean = true;

    if (this.holdType == EventHoldType.LOCAL_ONLY) {
      if (this.eventDatetimeFrom && this.eventDatetimeTo) {
        if (this.eventDatetimeTo <= this.eventDatetimeFrom) {
          this.$validator.errors.add({ field: "event-datetime-to", msg: "終了日時は開始日時より後の日時を指定してください" });
          validationResult = false;
        }
      }
    } else if (this.holdType == EventHoldType.LOCAL_AND_ONLINE || this.holdType == EventHoldType.ONLINE_ONLY) {
      if (this.eventDate && this.eventTimeFrom && this.eventTimeTo) {
        const fromDateStr = `${this.$dateUtil.replaceNonNumeric(this.eventDate)}${this.convertEventTime(this.eventTimeFrom)}`;
        const toDateStr = `${this.$dateUtil.replaceNonNumeric(this.eventDate)}${this.convertEventTime(this.eventTimeTo)}`;
        const fromNum = Number(fromDateStr);
        const toNum = Number(toDateStr);

        if (toNum <= fromNum) {
          this.$validator.errors.add({ field: "event-date", msg: "終了時間は開始時間より後の時間を指定してください" });
          validationResult = false;
        } else {
          const fromDate = this.$dateUtil.convertNumberToDate(fromNum);
          const toDate = this.$dateUtil.convertNumberToDate(toNum);
          const diffMinutes = (toDate.getTime() - fromDate.getTime()) / (1000 * 60);
          if (60 < diffMinutes) {
            this.$validator.errors.add({ field: "event-date", msg: "オンラインイベントの場合、実施時間は1時間までです" });
            validationResult = false;
          }
        }
      }
    }

    return validationResult;
  }

  /**
   * ### イベント登録
   */
  public async registerEvent(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "登録中...";

    // ファイルが添付されていればファイルのアップロード
    let fileUrls: Array<FileUrl> = [];
    try {
      if (0 < this.files.length) {
        const targetFiles = [];
        for (const file of this.files) {
          targetFiles.push(file.fileObject as File);
        }
        const urls: Array<S3LocationResponse> = await this.createUploadUrls(targetFiles, S3LocationType.EVENT);
        fileUrls = await this.uploadFiles(urls);
      }
    } catch (error) {
      this.isBusy = false;
      this.showUploadErrorModal = true;
      this.files = [];
      return;
    }

    const requestBody: EventPostModel = this.createRequestBody(fileUrls);
    await this.eventsService.post(userStore, requestBody);

    let eventList: EventListState = needRefreshesStore.eventList;
    eventList.eventList = true;
    needRefreshesStore.setEventList(eventList);

    this.showRegisterSuccessModal = true;
    tabIndexesStore.setEventTabIndex({ index: 1 });
    this.isBusy = false;

    return;
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createUploadUrls(files: Array<File>, s3LocationType: S3LocationType): Promise<Array<S3LocationResponse>> {
    let extensions: Array<string> = [];
    for (const file of files) {
      const _file: Array<string> = file.name.split("/");
      const _extensions: Array<string> = _file[_file.length - 1].split(".");
      extensions.push("." + _extensions[_extensions.length - 1]);
    }
    const params: S3LocationMessage = {
      userId: userStore.loginUser.userId
    };
    const requestBody: S3LocationRequest = {
      type: s3LocationType,
      count: files.length,
      extensions: extensions,
      params: params,
      acl: "public-read"
    };
    const url: Array<S3LocationResponse> = await this.s3LocationsService.post(userStore, requestBody);

    return url;
  }

  /**
   * ### プログレスローディングを表示してファイルアップロードする
   */
  public async uploadFiles(urls: Array<S3LocationResponse>): Promise<Array<FileUrl>> {
    const fileUrls: Array<FileUrl> = [];

    try {
      // プログレス付きモーダルを表示する
      // 進捗はファイルのアプロード状況を反映させるようにする
      this.currentUploadCount = 0;
      this.uploadCount = this.files.length;
      this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\n別画面に遷移しますと処理がキャンセルされます。";
      this.progressLoading = true;
      // アップロード
      for (let i = 0; i < urls.length; i++) {
        this.currentUploadCount = i;
        await this.s3UploadsService.uploadFile(urls[i], this.files[i].fileObject as File);

        // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
        const preUrl: string = urls[i].url.endsWith("/") ? urls[i].url : `${urls[i].url}/`;
        const s3Url: string = `${preUrl}${urls[i].fields["key"]}`;

        fileUrls.push({
          name: this.files[i].name,
          url: s3Url
        });
      }
      // アップロードしたファイルはサムネイル画像が作成されたり、movからmp4への変換が行われる
      // ファイルの存在確認をして変換されたか確認する
      await this.existFile(fileUrls);
    } finally {
      this.progressLoading = false;
    }

    return fileUrls;
  }

  /**
   * ### ファイルの存在確認を行う
   */
  public async existFile(fileUrls: Array<FileUrl>): Promise<void> {
    // ファイルがアップロードされているかをチェックする
    const s3Urls: string[] = [];
    for (const fileUrl of fileUrls) {
      s3Urls.push(fileUrl.url);
    }
    const fileRequestBody: ExistS3FilesPostModel = { urls: s3Urls };
    await this.existS3FilesService.post(userStore, fileRequestBody);

    // サムネイルのファイルが存在しているかをチェックする
    let thumbnailUrls: Array<string> = [];
    for (const s3Url of s3Urls) {
      // サムネイルのファイル名は<元ファイル名>_thumbnailになる
      const splitedUrl: string[] = s3Url.split("/");
      const splitedFileName: string[] = splitedUrl[splitedUrl.length - 1].split(".");

      // mov、mp4以外の場合はサムネイルをメッセージ送信時に作成するのでスキップ
      if (splitedFileName[1] != "mov" && splitedFileName[1] != "mp4") {
        continue;
      }

      const thumbnailFileName: string = splitedFileName[0] + "_thumbnail.jpeg";
      let thunmbnailUrl: string = "";
      for (let i = 0; i < splitedUrl.length - 1; i++) {
        thunmbnailUrl += splitedUrl[i] + "/";
      }
      thunmbnailUrl += thumbnailFileName;
      thumbnailUrls.push(thunmbnailUrl);
    }

    if (0 < thumbnailUrls.length) {
      const thumbnailRequestBody: ExistS3FilesPostModel = { urls: thumbnailUrls };
      await this.existS3FilesService.post(userStore, thumbnailRequestBody);
    }

    return;
  }

  /**
   * ### イベント登録パラメータ作成
   */
  public createRequestBody(attachedFiles: Array<FileUrl>): EventPostModel {
    if (!this.imageUrl) {
      const img: any = this.$refs.defaultImage;
      this.imageUrl = ImgElementToBase64.convert(img, "image/jpeg");
    }

    let targets: number[] = [];
    if (this.targetType != null && EventTargetType.RESIDENT_GROUP <= this.targetType) {
      for (const target of this.eventTargetSelectModalModel) {
        if (target.isChecked == true) {
          targets.push(target.id);
        }
      }
    }

    let replyDeadline: number | undefined = undefined;
    if (this.needReply == true) {
      const slicedReplyDeadline: string = this.replyDeadline.toString().slice(0, 8);
      replyDeadline = Number(`${slicedReplyDeadline}235959000`);
    }

    let meetingToken: string = "";
    if (this.holdType == EventHoldType.LOCAL_AND_ONLINE || this.holdType == EventHoldType.ONLINE_ONLY) {
      meetingToken = uuidv4();
    }

    let timeFrom = 0;
    let timeTo = 0;

    if (this.holdType == EventHoldType.LOCAL_ONLY) {
      timeFrom = Number(this.eventDatetimeFrom);
      timeTo = Number(this.eventDatetimeTo);
    } else {
      const eventDate: string = this.$dateUtil.replaceNonNumeric(this.eventDate);
      timeFrom = Number(`${eventDate}${this.convertEventTime(this.eventTimeFrom)}`);
      timeTo = Number(`${eventDate}${this.convertEventTime(this.eventTimeTo)}`);
    }

    const requestBody: EventPostModel = {
      timeFrom: timeFrom,
      timeTo: timeTo,
      targetType: this.targetType as EventTargetType,
      targets: targets,
      needReply: this.needReply,
      replyDeadline: replyDeadline,
      holdType: this.holdType as EventHoldType,
      place: this.$stringUtil.convertYen(this.place),
      title: this.$stringUtil.convertYen(this.title),
      description: this.$stringUtil.convertYen(this.description),
      attachedFiles: attachedFiles,
      image: this.imageUrl,
      meetingToken: meetingToken,
      writtenBy: userStore.loginUser.name,
      writerId: userStore.loginUser.userId
    };

    return requestBody;
  }

  /**
   * 文字列の時刻(hh:MM)を数値の日付(yyymmddhhMMssSSS)に変換する
   * - 時刻は時分の形式(例 00:20)なので、「:」を削除して、秒の部分を加える
   *   timepickerコンポーネントの仕様により、3桁(8:30等)がありえるので、3桁なら先頭を0埋めする
   *   ※分は2桁が約束されているので、1桁かどうかを意識するのは時間だけ
   */
  public convertEventTime(time: string): string {
    const nonNumeriTime: string = this.$dateUtil.replaceNonNumeric(time);
    return `${nonNumeriTime}000`;
  }

  /**
   * イベント一覧に遷移する
   */
  public gotoEventList(): void {
    this.$router.push(PcUrl.EventList);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

#event-register {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;

  .register-btn,
  .cancel-btn {
    width: 120px;
  }

  .target-select-btn {
    margin: 0 8px 4px 0;
  }
  .event-target {
    display: inline-block;
    padding: 7px;
    font-size: 16px;
    margin: 0 8px 4px 0;
    border-radius: 3px;
    transition: all 0.2s;
    border: 1px solid $form-border-color;

    .target-name {
      margin: 0 8px 0 0 !important;
    }
    .delete-btn {
      margin: 0 !important;
      font-size: 14px !important;
    }
  }
}
</style>
